var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BarChart',{attrs:{"title":_vm.title,"data":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }